'use client';
import { useField } from 'formik';

import CheckIcon from '@repo/ui/src/components/Icons/CheckIcon';
import { Markdown } from '@repo/ui/src/components/Markdown';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  label?: string;
  testId?: string;
  id: string;
  name: string;
  disabled?: boolean;
  labelStyle?: string;
}

const Checkbox = ({ label, testId, labelStyle, ...props }: Props) => {
  const [field, meta] = useField({ ...props, type: 'checkbox' });
  const showError = meta.touched && meta.error;

  return (
    <div>
      <label
        data-testid={testId}
        className={classNames(
          'tra-checkbox-label tw-mb-0 tra-text-web-body-m dark:tw-text-warm-100',
          meta.touched && meta.error && 'tw-text-red-400',
        )}
      >
        <input {...field} {...props} type="checkbox" className="tra-checkbox" />
        {field.checked ? (
          <CheckIcon
            className="tra-checkbox-check"
            color="white"
            svgFill={
              !props.disabled ? 'var(--tra-color-brand-300)' : 'var(--tra-color-neutral-300)'
            }
          />
        ) : null}

        {label && (
          <span className={classNames('tw-flex-1 tw-leading-6', labelStyle)}>
            <Markdown components={{ p: ({ children }: { children: React.ReactNode }) => <>{children}</> }}>{label}</Markdown>
          </span>
        )}
      </label>
      {showError ? (
        <span className="tra-input-error" id={`${props.name}-error`} data-testid="input-error">
          {meta.error}
        </span>
      ) : null}
    </div>
  );
};

export default Checkbox;
